import { render, staticRenderFns } from "./user-register.vue?vue&type=template&id=5159aa72&scoped=true&"
import script from "./user-register.vue?vue&type=script&lang=js&"
export * from "./user-register.vue?vue&type=script&lang=js&"
import style0 from "./user-register.vue?vue&type=style&index=0&id=5159aa72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159aa72",
  null
  
)

export default component.exports